<template>
<div></div>
</template>
<script>
import logo from '@/assets/court-logo.png'
export default {
name:'footerComponent',
data(){
  return {
    logo:logo,
  }
}
}
</script>
<style lang="scss" scoped>
footer {
  .court-logo {
   img {
      margin-right:16px;
   }
  }
 @media screen and (min-width:1024px){
    width: 100%;
    padding:24px 24px 0 324px; 
 }
 .padded{
   padding:16px 0px;
 }
  .court-sepa {
    border-bottom:1px solid rgba(0,0,0,.1);
    width: 100%;
  }
  .dyn-col {
    float: left;
  } 
  ul {
    &.navigation {
      padding: 0px;
      margin: 0px;
      display: inline-flex;
      line-height: 48px;
      li {
        margin-right: 12px;
        a {
          color:rgba(0,0,0,.8);
          font-size: 16px;
        }
      }
    }
  }
}
</style>